<template>
  <div class="homeswiper contentWidth">
    <div v-show="loading"
         style="height:470px; overflow: hidden;">
      <loading v-if="loading"></loading>
    </div>

    <el-carousel v-show="!loading && records"
                 :interval="5000"
                 height="470px">

      <div class="img_loaging" v-if="!records">
        <div class="error_img_conter">
          <img :src="error_login"
               alt="">
        </div>
      </div>

      <el-carousel-item v-for="(img,index) in records"
                        :key="index">
        <router-link :to="img.url"
                     class="aimgbox">
          <img :src="img.cover"
               class="fade_image_out"
               style="width:100%;height:470px; object-fit: cover;">
          <div class="maskbg"></div>
          <div class="title">{{img.title}}</div>

        </router-link>

      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import loading from '@/components/loading/loading.vue'
export default {
  name: "homeSwiper",
  data () {
    return {
      loading: true,
      records: [],
      defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require('@/assets/image/common/loading.gif'),

    }
  },
  components: {
    loading
  },
  methods: {
    getFindBanners () {
      this.$parent.getfindbanner().then((res) => {
        if (res.data.code == 200) {
          this.loading = false;
          this.records = res.data.data.records
        } else {
          this.loading = false;
          this.$message.error(res.data.message);
        }
      })
    }
  },
  mounted () {
    this.getFindBanners();
  }
}
</script>
<style lang="scss" scoped>
.homeswiper {
  margin: 0 auto;
}
.homeswiper >>> .el-carousel__button {
  width: 26px;
  height: 6px;
}
.homeswiper a.aimgbox {
  display: block;
  width: 100%;
  height: 470px;
  position: relative;
  div.maskbg {
    width: 100%;
    height: 470px;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.2);
  }
  div.title {
    width: 100%;
    height: 40px;
    position: absolute;
    bottom: 30px;
    left: 0;
    line-height: 40px;
    letter-spacing: 5px;
    text-align: center;
    color: #ccc;
    font-size: 20px;
    text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
  }
}
.img_loaging {
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 470px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error_img_conter {
  width: 100px;
  height: 100%;
}
.error_img_conter img {
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/homeSwiper.vue